import './noResultsFound.scss';

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface NoResultsFoundProps {
    className?: string,
    search?: string,
    children?: React.ReactNode,
    icon?: IconProp,
}

/**
 * Component to show when a search or query returned no results.
 */
export const NoResultsFound = (props: NoResultsFoundProps) => {
    const {
        className,
        search,
        children,
        icon
    } = props;

    const { t } = useTranslation();

    // Otherwise render th default contents.
    return (
        <div className={`no-results-found ${search ? 'no-results-found-search' : 'no-results-found-no-search'} ${className ?? ''}`}>
            <div className="no-results-found-icon">
                <FontAwesomeIcon icon={icon ?? ['far', 'frown']} />
            </div>
            {
                children ? children
                    : (
                        <p>
                            {
                                search ?
                                    t('notResultsFound.nothingMatchedSearch', 'Sorry there were no matches for "{{search}}."', { search: search })
                                    : t('notResultsFound.nothingFound', 'Sorry there is nothing to show you here yet.')
                            }
                        </p>
                        )
            }
        </div>
        );
};